export const PageNotFound = () => {
  return (
    <>
      <meta charSet="utf-8" />
      <meta content="width=device-width, initial-scale=1" name="viewport" />
      <html lang="en">
        <head>
          <title>404 - Not Found</title>
          <style>{`
            body {
                background-color: black;
                margin: 0;
                height: 100vh;
                display: flex;
                align-items: center;
                justify-content: center;
            }
    
            #svg404 {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
            }
        `}</style>
        </head>

        <body>
          <svg
            id="svg404"
            viewBox="0 0 400 400"
            xmlns="http://www.w3.org/2000/svg"
          >
            <style type="text/css">
              {`text {
                    font-family: Arial, Helvetica, sans-serif;
                }`}
            </style>
            <rect height="100%" style={{ fill: "black" }} width="100%" />

            <text
              fill="rgb(255,255,255)"
              font-family="Arial"
              font-size="60"
              x="165"
              y="210"
            >
              lost
            </text>
            <text
              fill="rgb(211,211,211)"
              font-family="Arial"
              font-size="14"
              x="20"
              y="40"
            >
              perdu
            </text>
            <text
              fill="rgb(169,169,169)"
              font-family="Arial"
              font-size="18"
              x="60"
              y="74"
            >
              kadonnut
            </text>
            <text
              fill="rgb(192,192,192)"
              font-family="Arial"
              font-size="24"
              x="30"
              y="380"
            >
              verloren
            </text>
            <text
              fill="rgb(128,128,128)"
              font-family="Arial"
              font-size="20"
              x="288"
              y="350"
            >
              потерянный
            </text>
            <text
              fill="rgb(105,105,105)"
              font-family="Arial"
              font-size="12"
              x="220"
              y="80"
            >
              失われた
            </text>
            <text
              fill="rgb(169,169,169)"
              font-family="Arial"
              font-size="8"
              x="220"
              y="320"
            >
              สูญหาย
            </text>
            <text
              fill="rgb(211,211,211)"
              font-family="Arial"
              font-size="22"
              x="180"
              y="143"
            >
              丢失
            </text>
            <text
              fill="rgb(105,105,105)"
              font-family="Arial"
              font-size="10"
              x="260"
              y="270"
            >
              잃어버린
            </text>
            <text
              fill="rgb(192,192,192)"
              font-family="Arial"
              font-size="16"
              x="150"
              y="30"
            >
              فقد
            </text>
            <text
              fill="rgb(169,169,169)"
              font-family="Arial"
              font-size="18"
              x="30"
              y="230"
            >
              אבד
            </text>
            <text
              fill="rgb(128,128,128)"
              font-family="Arial"
              font-size="20"
              x="312"
              y="180"
            >
              χαμένος
            </text>
            <text
              fill="rgb(105,105,105)"
              font-family="Arial"
              font-size="24"
              x="40"
              y="170"
            >
              förlorade
            </text>
            <text
              fill="rgb(192,192,192)"
              font-family="Arial"
              font-size="18"
              x="140"
              y="340"
            >
              tapt
            </text>
            <text
              fill="rgb(128,128,128)"
              font-family="Arial"
              font-size="14"
              x="310"
              y="100"
            >
              tabt
            </text>
            <text
              fill="rgb(211,211,211)"
              font-family="Arial"
              font-size="18"
              x="330"
              y="40"
            >
              galduta
            </text>
            <text
              fill="rgb(169,169,169)"
              font-family="Arial"
              font-size="12"
              x="40"
              y="90"
            >
              elveszett
            </text>
            <text
              fill="rgb(192,192,192)"
              font-family="Arial"
              font-size="20"
              x="80"
              y="310"
            >
              missed
            </text>
            <text
              fill="rgb(128,128,128)"
              font-family="Arial"
              font-size="10"
              x="240"
              y="370"
            >
              изгубен
            </text>
            <text
              fill="rgb(105,105,105)"
              font-family="Arial"
              font-size="14"
              x="130"
              y="110"
            >
              खो गया
            </text>
            <text
              fill="rgb(169,169,169)"
              font-family="Arial"
              font-size="22"
              x="240"
              y="250"
            >
              शेर हो गया
            </text>
            <text
              fill="rgb(211,211,211)"
              font-family="Arial"
              font-size="18"
              x="80"
              y="195"
            >
              stracony
            </text>
            <text
              fill="rgb(105,105,105)"
              font-family="Arial"
              font-size="10"
              x="270"
              y="220"
            >
              borta
            </text>
            <text
              fill="rgb(192,192,192)"
              font-family="Arial"
              font-size="16"
              x="130"
              y="50"
            >
              kayboldu
            </text>
            <text
              fill="rgb(169,169,169)"
              font-family="Arial"
              font-size="24"
              x="80"
              y="270"
            >
              tévedt
            </text>
            <text
              fill="rgb(128,128,128)"
              font-family="Arial"
              font-size="20"
              x="270"
              y="150"
            >
              vermisst
            </text>
            <text
              fill="rgb(105,105,105)"
              font-family="Arial"
              font-size="24"
              x="80"
              y="130"
            >
              perdido
            </text>
            <text
              fill="rgb(192,192,192)"
              font-family="Arial"
              font-size="10"
              x="340"
              y="290"
            >
              felizg
            </text>
            <text
              fill="rgb(128,128,128)"
              font-family="Arial"
              font-size="14"
              x="240"
              y="130"
            >
              verloren
            </text>
          </svg>
          ();
        </body>
      </html>
    </>
  );
};
